/* Tala Sophie — storefront behaviour. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) {
    var f = (window.TS && window.TS.moneyFormat) || '${{amount}}';
    var v = (c / 100).toFixed(2);
    if (f.indexOf('amount_no_decimals') > -1) v = Math.round(c / 100).toString();
    return f.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, v);
  };

  var suggestPrice = function (v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return money(Math.round(n * 100));
  };

  /* ---------------- overlay + panels ---------------- */
  var ovl = $('#ovl');
  var openPanel = null;
  function lock(on) { document.body.classList.toggle('no-scroll', on); }
  function close() {
    if (!openPanel) return;
    openPanel.classList.remove('on');
    openPanel.setAttribute('aria-hidden', 'true');
    if (ovl) ovl.classList.remove('on');
    lock(false);
    var t = openPanel.__trigger; openPanel = null;
    if (t && t.focus) t.focus();
    $$('.burger').forEach(function (b) { b.classList.remove('on'); b.setAttribute('aria-expanded', 'false'); });
  }
  function open(el, trigger) {
    if (!el) return;
    if (openPanel && openPanel !== el) { openPanel.classList.remove('on'); openPanel.setAttribute('aria-hidden', 'true'); }
    openPanel = el; el.__trigger = trigger || null;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    if (ovl) ovl.classList.add('on');
    lock(true);
    var f = el.querySelector('input[type="search"], [data-autofocus]');
    if (f) setTimeout(function () { f.focus(); }, 320);
  }
  if (ovl) ovl.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); open($('#' + o.getAttribute('data-open')), o); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
  });
  /* focus trap */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !openPanel) return;
    var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', openPanel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- generic accordion ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-acc]');
    if (!t) return;
    var p = document.getElementById(t.getAttribute('aria-controls'));
    var on = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!on));
    if (p) p.hidden = on;
  });

  /* ---------------- desktop mega menu (keyboard) ---------------- */
  $$('.nav-i').forEach(function (item) {
    var t = $('.nav-t', item), m = $('.mega', item);
    if (!t || !m) return;
    t.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault(); item.classList.add('on');
        var a = m.querySelector('a'); if (a) a.focus();
      }
    });
    item.addEventListener('focusout', function () {
      setTimeout(function () { if (!item.contains(document.activeElement)) item.classList.remove('on'); }, 0);
    });
    m.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('on'); t.focus(); } });
  });

  /* ---------------- burger ---------------- */
  $$('.burger').forEach(function (b) {
    b.addEventListener('click', function () {
      var el = $('#mnav');
      if (openPanel === el) { close(); return; }
      b.classList.add('on'); b.setAttribute('aria-expanded', 'true'); open(el, b);
    });
  });

  /* ---------------- cart ---------------- */
  var CART_SECTION = 'cart-drawer';
  function paint(html) {
    if (!html) return;
    var d = document.createElement('div'); d.innerHTML = html;
    var fresh = d.querySelector('#cd-inner');
    var live = $('#cd-inner');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    var n = fresh ? fresh.getAttribute('data-count') : null;
    if (n !== null) {
      if (live) live.setAttribute('data-count', n);
      setCount(parseInt(n, 10) || 0);
    }
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = n; });
  }
  function post(url, body) {
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }
  function err(msg, target) {
    var box = target ? target.closest('form') : null;
    var p = box ? box.querySelector('[data-form-error]') : null;
    if (p) { p.textContent = msg; p.hidden = false; }
    else if (window.console) console.warn('[cart]', msg);
  }

  /* add to cart (PDP form + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.innerHTML = '<span class="spin"></span>'; }
    var ep = form.querySelector('[data-form-error]'); if (ep) ep.hidden = true;
    var fd = new FormData(form);
    var qty = parseInt(fd.get('quantity'), 10); if (!qty || qty < 1) qty = 1;
    post('/cart/add.js', { items: [{ id: fd.get('id'), quantity: qty }] })
      .then(function (r) {
        if (!r.ok) { err((r.body && r.body.description) || 'Could not add this item.', form); return; }
        paint(r.body.sections && r.body.sections[CART_SECTION]);
        open($('#cart-drawer'), btn);
      })
      .catch(function () { err('Network error — please try again.', form); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  });

  /* qty +/- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty-step]');
    if (!s) return;
    var wrap = s.closest('.qty'); var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 0;
    var v = (parseInt(input.value, 10) || 0) + parseInt(s.getAttribute('data-qty-step'), 10);
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* cart line changes */
  function changeLine(line, quantity, node) {
    var root = node && node.closest('.ci'); if (root) root.classList.add('is-loading');
    post('/cart/change.js', { line: line, quantity: quantity })
      .then(function (r) {
        if (!r.ok) { if (root) root.classList.remove('is-loading'); return; }
        if ($('#cd-inner')) paint(r.body.sections && r.body.sections[CART_SECTION]);
        if (document.body.classList.contains('tpl-cart')) window.location.reload();
        else setCount(r.body.item_count);
      })
      .catch(function () { if (root) root.classList.remove('is-loading'); });
  }
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-qty]');
    if (!i) return;
    changeLine(i.getAttribute('data-line-qty'), parseInt(i.value, 10) || 0, i);
  });
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-line-remove]');
    if (!r) return;
    e.preventDefault();
    changeLine(r.getAttribute('data-line-remove'), 0, r);
  });

  /* ---------------- predictive search ---------------- */
  var sInput = $('[data-search-input]'), sRes = $('[data-search-results]');
  if (sInput && sRes) {
    var timer, lastQ = '', ac;
    var render = function (q, data) {
      var P = (data.resources && data.resources.results.products) || [];
      var Q = (data.resources && data.resources.results.queries) || [];
      var C = (data.resources && data.resources.results.collections) || [];
      if (!P.length && !Q.length && !C.length) {
        sRes.innerHTML = '<p class="ps-empty">No matches for &ldquo;' + q.replace(/[<>&]/g, '') +
          '&rdquo;. Try a different word, or <a class="lnk" href="/collections/all">browse all jewelry</a>.</p>';
        sRes.hidden = false; return;
      }
      var left = '';
      if (Q.length) left += '<p class="mega-h">Suggestions</p><div class="ps-q">' +
        Q.slice(0, 5).map(function (x) { return '<a href="' + x.url + '">' + x.styled_text + '</a>'; }).join('') + '</div>';
      if (C.length) left += '<p class="mega-h" style="margin-top:20px">Collections</p><div class="ps-q">' +
        C.slice(0, 5).map(function (x) { return '<a href="' + x.url + '">' + x.title + '</a>'; }).join('') + '</div>';
      var right = '<p class="mega-h">Products</p><div class="ps-p">' + P.slice(0, 8).map(function (p) {
        var src = '';
        if (p.featured_image && p.featured_image.url) {
          src = p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        }
        var img = src
          ? '<img src="' + src + '" alt="" loading="lazy" width="400" height="400">'
          : '<div class="ph"></div>';
        return '<a class="ps-i" href="' + p.url + '">' + img +
          '<span class="t">' + p.title + '</span><span class="p">' + suggestPrice(p.price) + '</span></a>';
      }).join('') + '</div><a class="lnk" style="display:inline-block;margin-top:20px;font-size:13px" href="/search?q=' +
        encodeURIComponent(q) + '">See all results</a>';
      sRes.innerHTML = '<div class="ps-g"><div>' + (left || '') + '</div><div>' + right + '</div></div>';
      sRes.hidden = false;
    };
    var run = function () {
      var q = sInput.value.trim();
      if (q.length < 2) { sRes.hidden = true; sRes.innerHTML = ''; lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      if (ac) ac.abort();
      ac = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last',
        { signal: ac.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(q, d); })
        .catch(function () { });
    };
    sInput.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
  }

  /* ---------------- PDP gallery ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('.slide', g), thumbs = $$('[data-gthumb]', g), dots = $$('[data-gdot]', g);
    var main = $('.gal-main', g);
    function go(i) {
      slides.forEach(function (s, n) { s.classList.toggle('on', n === i); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      dots.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      if (main) main.classList.remove('zoomed');
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    if (main) {
      main.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width:899px)').matches) return;
        main.classList.toggle('zoomed');
        if (main.classList.contains('zoomed')) {
          var r = main.getBoundingClientRect();
          var img = $('.slide.on img', g);
          if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        }
      });
    }
    /* swipe */
    var x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 42) return;
        var cur = slides.findIndex(function (s) { return s.classList.contains('on'); });
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next >= 0 && next < slides.length) go(next);
      }, { passive: true });
    }
  });

  /* ---------------- sticky add to cart ---------------- */
  var satc = $('[data-satc]'), anchor = $('[data-satc-anchor]');
  if (satc && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      satc.classList.toggle('on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { rootMargin: '0px' }).observe(anchor);
  }

  /* ---------------- collection filters ---------------- */
  var ff = $('[data-filter-form]');
  if (ff) {
    var deb;
    var apply = function () {
      var fd = new FormData(ff);
      var qs = new URLSearchParams();
      fd.forEach(function (v, k) { if (String(v).length) qs.append(k, v); });
      var url = window.location.pathname + (qs.toString() ? '?' + qs.toString() : '');
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          ['[data-grid-wrap]', '[data-filter-form]', '[data-active-chips]', '[data-result-count]'].forEach(function (sel) {
            var fresh = d.querySelector(sel), live = document.querySelector(sel);
            if (fresh && live) live.innerHTML = fresh.innerHTML;
          });
          history.replaceState({}, '', url);
          window.scrollTo({ top: (document.querySelector('.cbar') || document.body).offsetTop - 120, behavior: 'smooth' });
        })
        .catch(function () { window.location.href = url; });
    };
    ff.addEventListener('change', function (e) {
      if (e.target.type === 'number' || e.target.type === 'text') return;
      apply();
    });
    ff.addEventListener('input', function (e) {
      if (e.target.type !== 'number' && e.target.type !== 'text') return;
      clearTimeout(deb); deb = setTimeout(apply, 650);
    });
    ff.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
  }
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sortSel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------------- recently viewed ---------------- */
  var KEY = 'ts_recent';
  function readRecent() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  var cur = document.body.getAttribute('data-product-handle');
  if (cur) {
    try {
      var list = readRecent().filter(function (h) { return h !== cur; });
      list.unshift(cur);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { }
  }
  var rvMount = $('[data-recent]');
  if (rvMount) {
    var handles = readRecent().filter(function (h) { return h !== cur; }).slice(0, 4);
    if (!handles.length) { rvMount.remove(); }
    else {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=card')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (parts) {
        var html = parts.filter(Boolean).join('');
        if (!html.trim()) { rvMount.remove(); return; }
        var t = $('[data-recent-grid]', rvMount);
        if (t) { t.innerHTML = html; rvMount.hidden = false; }
      });
    }
  }


  /* ---------------- variant picker ----------------
     The live catalogue is 100% single-variant, so this path is currently inert.
     It is here so that adding a colour or size option in Shopify works without a code change. */
  $$('[data-variant-data]').forEach(function (store) {
    var variants;
    try { variants = JSON.parse(store.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;
    var form = store.closest('form');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]');
    var priceEl = document.querySelector('.pinfo .price');
    var stockEl = document.querySelector('.pinfo .stock');

    function selected() {
      return $$('[data-variant-option]', form)
        .filter(function (i) { return i.checked; })
        .map(function (i) { return i.value; });
    }
    function match(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v['option' + (i + 1)] === o; });
      });
    }
    function sync() {
      var v = match(selected());
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to bag' : 'Sold out';
      }
      if (priceEl) {
        var html = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<s>' + money(v.compare_at_price) + '</s>' + html;
        }
        priceEl.innerHTML = html;
      }
      var sp = $('[data-satc-price]');
      if (sp) sp.textContent = money(v.price);
      if (stockEl) {
        stockEl.classList.toggle('out', !v.available);
        stockEl.textContent = v.available ? 'In stock, ready to ship' : 'Sold out';
      }
      if (v.featured_media && v.featured_media.position) {
        var thumbs = $$('[data-gthumb]');
        var t = thumbs[v.featured_media.position - 1];
        if (t) t.click();
      }
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-variant-option')) sync();
    });
  });

  /* ---------------- sticky add-to-cart button ---------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-satc-add]')) return;
    var f = document.getElementById('product-form');
    if (!f) return;
    if (f.requestSubmit) f.requestSubmit();
    else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* ---------------- announcement rotation ---------------- */
  var annItems = $$('[data-ann-item]');
  if (annItems.length > 1 && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    var ai = 0;
    setInterval(function () {
      annItems[ai].hidden = true;
      ai = (ai + 1) % annItems.length;
      annItems[ai].hidden = false;
    }, 4200);
  }
})();

/* ---------------------------------------------------------------------------
   Bundle & Save ladder, gap filler, and offer countdown.
   Thresholds live in the markup (rendered from theme settings) — never here.
---------------------------------------------------------------------------- */
(function () {
  function ladders() { return document.querySelectorAll('[data-bundle-ladder]'); }

  function fmt(root, d) {
    return (root.getAttribute('data-mprefix') || '') + d.toFixed(2) + (root.getAttribute('data-msuffix') || '');
  }

  /* Milestones sit at even intervals, so the fill is interpolated segment by
     segment. A pure value-to-width mapping would make the bar disagree with the
     labels as soon as the thresholds are unevenly spaced (30/35/55/75). */
  function fillPct(subtotal, stops) {
    var n = stops.length;
    if (!n) return 0;
    var seg = 100 / n;
    if (subtotal >= stops[n - 1]) return 100;
    for (var i = 0; i < n; i++) {
      if (subtotal < stops[i]) {
        var lo = i === 0 ? 0 : stops[i - 1];
        var span = stops[i] - lo;
        var within = span > 0 ? (subtotal - lo) / span : 0;
        if (within < 0) within = 0;
        return (i * seg) + (within * seg);
      }
    }
    return 100;
  }

  /* Reorder the carousel so the pieces that actually close the current gap come
     first. Cards are never hidden: .bld__pick sets `display`, which overrides
     the browser's [hidden] rule, so hiding by attribute silently fails. */
  function paintFiller(root, gap) {
    var box = root.querySelector('[data-bld-filler]');
    if (!box) return;
    var list = root.querySelector('[data-bld-picks]');
    var picks = [].slice.call(root.querySelectorAll('[data-pick-price]'));
    if (!list || !picks.length) { box.hidden = true; return; }
    box.hidden = false;

    var closers = 0;
    var ranked = picks.map(function (el) {
      var price = parseFloat(el.getAttribute('data-pick-price')) || 0;
      var closes = gap > 0 && price >= gap;
      if (closes) closers++;
      // closers first (cheapest closer wins), then the dearest that still help
      var rank = closes ? price - gap : 1e6 + (gap - price);
      return { el: el, rank: rank, closes: closes };
    }).sort(function (a, b) { return a.rank - b.rank; });

    // Build off-document: with ~120 cards, appending one at a time thrashes layout.
    var frag = document.createDocumentFragment();
    ranked.forEach(function (o) {
      o.el.classList.toggle('is-closer', o.closes);
      frag.appendChild(o.el);
    });
    list.appendChild(frag);

    list.scrollLeft = 0;
    var h = root.querySelector('[data-bld-filler-h]');
    if (h) {
      if (gap <= 0) h.textContent = 'Add more pieces';
      else if (closers) h.textContent = 'Add one of these and you\u2019re there';
      else h.textContent = 'Popular pieces to get you closer';
    }
    syncArrows(root);
  }

  function syncArrows(root) {
    var list = root.querySelector('[data-bld-picks]');
    var prev = root.querySelector('[data-bld-prev]');
    var next = root.querySelector('[data-bld-next]');
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth;
    var scrollable = max > 2;
    if (prev) { prev.disabled = !scrollable || list.scrollLeft <= 1; }
    if (next) { next.disabled = !scrollable || list.scrollLeft >= max - 1; }
  }

  function paint(subtotal) {
    var list = ladders();
    for (var n = 0; n < list.length; n++) {
      var root = list[n];
      var marks = [].slice.call(root.querySelectorAll('[data-bld-mark]'));
      var stops = marks.map(function (m) { return parseFloat(m.getAttribute('data-bld-mark')) || 0; });

      var fill = root.querySelector('[data-bld-fill]');
      if (fill) fill.style.width = fillPct(subtotal, stops) + '%';

      var nextAt = null, nextWhat = '', bestWhat = '';
      marks.forEach(function (m, i) {
        var on = subtotal >= stops[i];
        m.classList.toggle('is-on', on);
        m.classList.remove('is-active');
        var em = m.querySelector('em');
        var what = em ? em.textContent.trim() : '';
        if (on) bestWhat = what;
        if (!on && nextAt === null) { nextAt = stops[i]; nextWhat = what; }
      });
      for (var m2 = marks.length - 1; m2 >= 0; m2--) {
        if (marks[m2].classList.contains('is-on')) { marks[m2].classList.add('is-active'); break; }
      }

      var save = root.querySelector('[data-bld-save]');
      if (save) {
        if (bestWhat) { save.textContent = bestWhat + ' unlocked'; save.hidden = false; }
        else save.hidden = true;
      }

      var gap = nextAt === null ? 0 : (nextAt - subtotal);
      var hint = root.querySelector('[data-bld-hint]');
      if (hint) {
        if (nextAt !== null) {
          hint.innerHTML = 'Add <b>' + fmt(root, gap) + '</b> to unlock <b>' + nextWhat + '</b>';
        } else if (bestWhat) {
          hint.innerHTML = 'You’re at the best bundle price — <b>' + bestWhat + '</b>';
        } else hint.textContent = '';
      }

      paintFiller(root, gap);
    }
  }

  function refresh() {
    if (!ladders().length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint((c.items_subtotal_price || 0) / 100); })
      .catch(function () {});
  }
  window.tsLadderRefresh = refresh;

  /* carousel nav — one viewport-width step per click */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bld-prev],[data-bld-next]');
    if (!btn) return;
    var root = btn.closest('[data-bundle-ladder]');
    var list = root && root.querySelector('[data-bld-picks]');
    if (!list) return;
    var step = Math.max(160, Math.round(list.clientWidth * 0.8));
    list.scrollBy({ left: btn.hasAttribute('data-bld-next') ? step : -step, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var list = e.target;
    if (list && list.hasAttribute && list.hasAttribute('data-bld-picks')) {
      syncArrows(list.closest('[data-bundle-ladder]'));
    }
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-bundle-ladder]').forEach(syncArrows);
  });

  var _fetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = (a && a.url) || a || '';
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
    }
    return p;
  };

  /* ---- offer countdown: real end date only, never restarts --------------- */
  function pad(x) { return (x < 10 ? '0' : '') + x; }
  function tick() {
    var els = document.querySelectorAll('[data-offer-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], raw = el.getAttribute('data-ends') || '';
      var t = Date.parse(raw.replace(' ', 'T'));
      if (isNaN(t)) t = Date.parse(raw);
      if (isNaN(t)) { el.hidden = true; continue; }
      var left = t - Date.now();
      if (left <= 0) { el.hidden = true; continue; }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      var c = el.querySelector('[data-ocd-clock]');
      if (c) {
        c.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        c.setAttribute('datetime', new Date(t).toISOString());
      }
      el.hidden = false;
    }
  }

  function start() {
    refresh();
    if (document.querySelector('[data-offer-countdown]')) { tick(); setInterval(tick, 1000); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
